<template>
  <div class="q-pa-md">
    <div
      class="update-customer bg-white q-pa-md my-box"
      v-if="!activeCustomer.id"
    >
      <div class="text-primary">Please select customer.</div>
    </div>
    <div class="update-customer bg-white q-pa-md my-box" v-else>
      <q-expansion-item
        icon="personal"
        label="Basic infomation"
        class="text-primary"
      >
        <div class="q-pa-md content">
          <q-form @submit="onSubmitBasicInfomation">
            <q-input
              dense
              label="Customer name"
              v-model="basicInfo.data.firstname"
              :rules="[(val) => !!val || 'first name is required']"
            ></q-input>
            <q-input
              dense
              label="Customer name"
              v-model="basicInfo.data.lastname"
              :rules="[(val) => !!val || 'last name is required']"
            ></q-input>
            <q-input
              dense
              label="Phone number"
              v-model="basicInfo.data.phone_number"
              :rules="[(val) => !!val || 'phone number is required']"
            ></q-input>
            <q-input
              dense
              label="Customer email (optional)"
              v-model="basicInfo.data.email"
            ></q-input>
            <div class="row q-pt-md full-width justify-end">
              <q-btn
                :loading="loading"
                :disable="basicInfo.isUpdate"
                icon="save"
                flat
                color="primary"
                label="Save"
                type="submit"
              ></q-btn>
            </div>
          </q-form>
        </div>
      </q-expansion-item>
      <q-expansion-item
        icon="personal"
        label="Shipping infomation"
        class="text-primary"
      >
        <div class="q-pa-md content">
          <div class="full-width q-pb-md">
            <q-icon name="map" size="24px"></q-icon>
            Current address: <span>{{ formatedAddress }}</span>
          </div>
          <div class="edit-map" v-if="canEditShippingInfo">
            <q-input
              outlined
              dense
              placeholder="Search new address.. e.g. 10400"
              v-model="addressKeyword"
            ></q-input>
            <div class="location-list" v-if="predictList">
              <q-list bordered separator>
                <q-item
                  clickable
                  @click="selectedIndex = index"
                  :active="index == selectedIndex"
                  v-for="(address, index) in predictList"
                  :key="index"
                >
                  <q-item-section>{{ address.description }}</q-item-section>
                </q-item>
              </q-list>
            </div>
            <div ref="dummymap" />
            <div class="col-12 map" :style="getStyle">
              <GmapMap
                ref="map"
                :center="mapCenter"
                :zoom="15"
                map-type-id="roadmap"
                style="width: 100%; height: 100%"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: true,
                  clickableIcons: false,
                }"
                @center_changed="updateCenter"
                @idle="sync"
                @dragstart="draging = true"
                @dragend="draging = false"
              >
              </GmapMap>
              <i
                class="fixed-marker fas fa-map-marker-alt"
                aria-hidden="true"
              ></i>
            </div>
            <div class="text-subtitle2 text-accent">
              For speed of delivery and cost calculation, please move the
              coordinate as close as customer location as possible.
            </div>
            <div class="text-subtitle2 text-accent">
              เพิ่อให้การจัดส่งรวดเร็วและคำนวณค่าส่งได้ถูกต้อง
              กรุณาปักหมุดให้ใกล้กับที่อยู่ของลูกค้าให้มากที่สุด
            </div>
            <div class="row q-pt-md full-width justify-end">
              <q-btn
                :loading="loading"
                :disable="selectedIndex < 0"
                flat
                color="primary"
                label="Next"
                @click="onEditShippingInfo"
              ></q-btn>
            </div>
          </div>
          <q-form v-else>
            <q-input
              dense
              label="Place name, e.g. My home / Office / Parent's home"
              error-message="place name is required"
              :error="!shippingInfoValid.name"
              v-model="shippingInfo.name"
            ></q-input>
            <q-input
              dense
              label="Address detail, e.g. address no/ town/ street"
              error-message="address is required"
              :error="!shippingInfoValid.address"
              v-model="shippingInfo.address"
            ></q-input>
            <q-input
              dense
              label="Sub district"
              error-message="Sub district is required"
              :error="!shippingInfoValid.subDistrict"
              v-model="shippingInfo.subDistrict"
            ></q-input>
            <q-input
              dense
              label="District"
              error-message="District is required"
              :error="!shippingInfoValid.district"
              v-model="shippingInfo.district"
            ></q-input>
            <q-input
              dense
              label="Province"
              error-message="Province is required"
              :error="!shippingInfoValid.province"
              v-model="shippingInfo.province"
            ></q-input>
            <q-input
              dense
              label="Postcode"
              error-message="Postcode is required"
              :error="!shippingInfoValid.postcode"
              v-model="shippingInfo.postcode"
            ></q-input>
            <div class="row q-pt-md full-width justify-end">
              <q-btn
                :loading="loading"
                :disable="!canUpdateShippingInfo"
                icon="save"
                flat
                color="primary"
                label="Save"
                @click="onSubmitShippingInfomation"
              ></q-btn>
            </div>
          </q-form>
        </div>
      </q-expansion-item>
      <div class="row q-pt-md full-width justify-end">
        <q-btn
          :loading="loading"
          flat
          color="primary"
          icon="arrow_back"
          label="Back"
          @click="onBack"
        ></q-btn>
      </div>
    </div>
    <q-dialog v-model="updateDialog.show" persistent>
      <DialogAlert
        message="Information updated"
        left-btn="OK"
        @leftClick="updateDialog.show = false"
      />
    </q-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import { debounce } from "debounce";
import { QExpansionItem, QDialog } from "quasar";

const components = { QExpansionItem, QDialog };

export default {
  name: "UpdateCustomer",
  components: {
    ...components,
    DialogAlert: () => import(`@/ui/components/DialogAlert.vue`),
  },
  data() {
    return {
      updateDialog: {
        show: false,
      },
      basicInfo: {
        isUpdate: true,
        data: {
          firstname: null,
          lastname: null,
          phone_number: null,
          email: null,
        },
      },

      shippingInfo: {
        name: null,
        address: null,
        province: null,
        subDistrict: null,
        district: null,
        postcode: null,
        location: null,
      },
      canEditShippingInfo: true,
      addressKeyword: null,
      mapCenter: { lat: 13.736717, lng: 100.523186 },
      reportedMapCenter: { lat: 13.736717, lng: 100.523186 },
      currentPlace: null,
      predictList: [],
      selectedIndex: -1,
    };
  },
  computed: {
    ...mapState({
      activeCustomer: (state) => state["activeCustomer"]["customer"],
      loading: (state) => state["cartData"]["loading"],
      customers: (state) => state["sale"]["customers"],
      activeCustomerID: (state) => state["activeCustomer"]["customer"]["id"],
      shippingType: (state) => state["checkout"]["shippingType"],
    }),
    google: gmapApi,
    getStyle() {
      if (this.selectedIndex < 0) {
        return "display: none;";
      }
      return "";
    },
    shippingInfoValid() {
      return {
        name: this.shippingInfo.name ? true : false,
        address: this.shippingInfo.address ? true : false,
        subDistrict: this.shippingInfo.subDistrict ? true : false,
        district: this.shippingInfo.district ? true : false,
        province: this.shippingInfo.province ? true : false,
        postcode: this.shippingInfo.postcode ? true : false,
      };
    },
    canUpdateShippingInfo() {
      return (
        this.shippingInfoValid.name &&
        this.shippingInfoValid.address &&
        this.shippingInfoValid.subDistrict &&
        this.shippingInfoValid.district &&
        this.shippingInfoValid.province &&
        this.shippingInfoValid.postcode
      );
    },
    formatedAddress() {
      if (this.activeCustomer) {
        const address = this.activeCustomer.address[0];
        return `${address.address} ${address.subDistrict || ""} ${
          address.district || ""
        } ${address.province} ${address.postcode}`;
      }
      return "";
    },
  },
  watch: {
    addressKeyword: {
      immediate: false,
      handler(val) {
        this.onQuery(val);
      },
    },
    selectedIndex: {
      immediate: false,
      handler(val) {
        console.log("selectedIndex");
        if (val == -1) {
          return;
        }
        this.onChooseAddress(this.predictList[val]);
      },
    },
    activeCustomer: {
      immediate: false,
      handler: function (val) {
        this.fetchCustomerInfo();
      },
    },
    "basicInfo.data": {
      immediate: false,
      handler: function (value) {
        console.log("watch -> basicInfo.data", value);
        this.basicInfo.isUpdate = false;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.activeCustomer.id) {
      this.fetchCustomerInfo();
    }
  },
  methods: {
    async onQuery(keyword) {
      this.predictList = [];
      this.selectedIndex = -1;
      if (keyword === null) {
        return;
      }
      if (keyword === undefined) {
        return;
      }
      if (keyword === "") {
        return;
      }
      const google = this.google;
      console.log("Query with keyword: " + keyword);
      console.log("Google: ", google);
      const service = new google.maps.places.AutocompleteService();
      service.getQueryPredictions(
        {
          input: keyword,
          location: new google.maps.LatLng(13.736717, 100.523186),
          radius: 550000,
        },
        (predictions, status) => {
          console.log("Query result: ", predictions);
          if (predictions) {
            predictions.forEach((item) => console.log(item.description));
            this.predictList = predictions;
          }
        }
      );
    },
    async onEditShippingInfo() {
      console.log("onEditShippingInfo");
      if (!this.activeCustomer.id) {
        console.log("no selected customer");
        return;
      }
      if (this.canEditShippingInfo) {
        if (this.selectedIndex >= 0) {
          await this.getLocationDetail(this.mapCenter);
        }
      }
      this.canEditShippingInfo = !this.canEditShippingInfo;
    },
    async onChooseAddress(address) {
      const google = this.google;
      const service = new google.maps.places.PlacesService(this.$refs.dummymap);
      const request = {
        placeId: address.place_id,
        fields: ["address_components", "geometry", "formatted_address"],
      };

      await service.getDetails(request, (result, status) => {
        this.address.location = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
        };
        this.reportedMapCenter = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
        };
        this.sync();
        console.log("getDetails:", result);
      });
    },
    getAddressComponent(addressList) {
      addressList.forEach((address) => {
        address.address_components.forEach((ac) => {
          ac.types.forEach((t) => {
            if (t == "postal_code" && this.shippingInfo.postcode === null) {
              console.log("postal code found", ac.long_name);
              this.shippingInfo.postcode = ac.long_name;
            }
            if (
              t == "administrative_area_level_1" &&
              !this.shippingInfo.province
            ) {
              console.log("province found", ac.long_name);
              this.shippingInfo.province = ac.long_name;
            }
            if (
              (t == "administrative_area_level_2" ||
                t == "sublocality_level_1") &&
              !this.shippingInfo.district
            ) {
              console.log("district found", ac.long_name);
              this.shippingInfo.district = ac.long_name;
            }
            if (
              (t == "sublocality_level_2" || t == "locality") &&
              !this.shippingInfo.subDistrict
            ) {
              console.log("subdistrict found", ac.long_name);
              this.shippingInfo.subDistrict = ac.long_name;
            }
          });
        });
      });
    },
    async updateCenter(latLng) {
      console.log("update center");
      this.reportedMapCenter = {
        lat: latLng.lat(),
        lng: latLng.lng(),
      };
    },
    sync() {
      console.log("sync!");
      this.mapCenter = this.reportedMapCenter;
      this.address = {
        ...this.address,
        location: {
          lat: this.reportedMapCenter.lat,
          lng: this.reportedMapCenter.lng,
        },
      };
    },
    getLocationDetail: debounce(async function (latLng) {
      this.shippingInfo.location = latLng;
      const google = this.google;
      const service = new google.maps.Geocoder();
      const request = {
        location: latLng,
      };

      try {
        await service.geocode(request, (result, status) => {
          console.log("getGmapPostalCode:", result);
          this.getAddressComponent(result);
        });
      } catch (err) {
        console.log(err);
      }
    }, 300),
    fetchCustomerInfo() {
      this.basicInfo.data.firstname = this.activeCustomer.firstname;
      this.basicInfo.data.lastname = this.activeCustomer.lastname;
      this.basicInfo.data.phone_number = this.activeCustomer.phone_number;
      this.basicInfo.data.email = this.activeCustomer.email;
    },
    onSubmitBasicInfomation() {
      console.log("onSubmitBasicInfomation", this.basicInfo.data);

      const payload = {
        id: this.activeCustomer.id,
        ...this.basicInfo.data,
      };

      console.log("payload: ", payload);
      try {
        this.$store.dispatch("sale/updateCustomer", payload);
        const address = {
          id: this.activeCustomer.address[0].id,
          firstname: this.basicInfo.data.firstname,
          lastname: this.basicInfo.data.lastname,
          phone: this.basicInfo.data.phone_number,
          email: this.basicInfo.data.email,
        };
        this.$store.dispatch("sale/updateCustomerAddress", address);
        console.log("data is updated");
        this.basicInfo.isUpdate = true;
        this.updateDialog.show = true;
      } catch (err) {
        throw new Error(err);
      }
    },
    onSubmitShippingInfomation() {
      const payload = {
        ...this.shippingInfo,
        id: this.activeCustomer.address[0].id,
        firstname: this.activeCustomer.firstname,
        lastname: this.activeCustomer.lastname,
        phone: this.activeCustomer.phone_number,
        email: this.activeCustomer.email,
      };

      console.log("onSubmitShippingInfomation", payload);

      try {
        this.$store.dispatch("sale/updateCustomerAddress", payload);
        console.log("data is updated");
        this.addressKeyword = null;
        this.canEditShippingInfo = true;
        this.selectedIndex = -1;
        this.updateDialog.show = true;
      } catch (err) {
        throw new Error(err);
      }
    },
    onBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.my-box {
  border-radius: 10px;
}
.fixed-marker-label {
  position: absolute;
  left: 50%;
  top: calc(50% - 40px);
  font-size: 12px;
  color: white;
  width: 70%;
  transform: translate(-50%, -50%);
  background-color: lightslategrey;
  padding: 4px;
}
.fixed-marker-label-address {
  color: white;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fixed-marker {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 28px;
  color: #c72027;
  transform: translate(-50%, -50%);
}
.map {
  position: relative;
  height: calc(50vh - 100px) !important;
}
.map-loading {
  display: grid;
  min-height: 300px;
  width: 100%;
}
.content {
  border: 1px solid #ed7246;
  border-radius: 10px;
}
</style>